var magicStyles = [".time[data-v-ca5fa0cc] {\n  margin: 0;\n  pointer-events: none;\n}\n.text[data-v-ca5fa0cc] {\n  font-size: var(--magic-time-font-size, 13px);\n  color: inherit;\n}"];

export default magicStyles;
